import React, { useRef } from 'react';

import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  DropdownButtonContainer,
  DropdownButtonLeft,
  ButtonLabel,
  DropdownButtonRight,
  DropdownListContainer,
  DropdownItemButton,
  DropdownItemLabel,
  ExpandIcon,
} from './styles';

/**
 * This is a button with extra dropdown options
 *
 * @param {{}} value current button option
 * @param {[{}]} options list of objects that should all have a label to display. Clicked option will be sent to handleClick
 * @param {function} handleClick function that will receive clicked option
 */
export default function DropdownButton({ value, options, handleClick, leftDrop, title, id }) {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);

  const toggleDropdown = () => setIsActive(!isActive);

  const optionClick = (option) => {
    handleClick(option);
    setIsActive(false);
  };

  return (
    <DropdownButtonContainer title={title} ref={dropdownRef} id={id}>
      <DropdownButtonLeft onClick={() => handleClick(value)}>
        <ButtonLabel>{value.label}</ButtonLabel>
      </DropdownButtonLeft>
      <DropdownButtonRight onClick={toggleDropdown}>
        <ExpandIcon isOpen={isActive} />
      </DropdownButtonRight>
      {isActive && (
        <DropdownListContainer leftDrop={leftDrop}>
          {options.map((option, index) => (
            <DropdownItemButton key={index} onClick={() => optionClick(option)}>
              <DropdownItemLabel>{option.label}</DropdownItemLabel>
            </DropdownItemButton>
          ))}
        </DropdownListContainer>
      )}
    </DropdownButtonContainer>
  );
}
